import { PropsWithChildren } from 'react';

import { Money } from '@betterment/js-runtime';
import { Box } from '@betterment/samba-react';
import { useParentSize } from '@visx/responsive';

import { ProjectionDisclosures } from './ProjectionDisclosures';

import { BalanceProjectionChartLegend } from '../../../purpose/components/projection-card/components/chart/ProjectionChartLegend';
import { ProjectionChart } from '../../../Shared/components-v2/charts/projection-chart/ProjectionChart';
import { ForecasterBalanceProjectionItemFragment } from '../graphql/forecasterBalanceProjectionItem.generated';
import { ForecasterProjectionDisclosuresFragment } from '../graphql/forecasterProjectionDisclosures.generated';

type Props = {
  timeSeries: ForecasterBalanceProjectionItemFragment[];
  children?: React.ReactNode | React.ReactNode[];
  disclosures: ForecasterProjectionDisclosuresFragment;
  targetAmount?: Money | null;
};

const Root = ({ targetAmount, disclosures, timeSeries, children }: Props) => {
  const { width, parentRef } = useParentSize();
  return (
    <Box ref={parentRef} css={{ display: 'flex', flexDirection: 'column', gap: 'space.300', minWidth: 'size.0' }}>
      {children}
      <BalanceProjectionChartLegend />
      <ProjectionChart
        data={timeSeries}
        width={width}
        height={300}
        target={targetAmount?.cents}
        margin={{ top: 5, right: 22, bottom: 20, left: 42 }}
      />
      <ProjectionDisclosures disclosures={disclosures} />
    </Box>
  );
};

const Header: React.FC<PropsWithChildren> = ({ children }) => (
  <Box css={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 'space.300' }}>{children}</Box>
);

export const ForecasterProjectionChart = Object.assign(Root, { Header });
